<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">SMS karte ({{ totalRecords }}) ({{ totalPrice }} EUR)</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>

                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Broj telefona</h4>
                            <base-input type="text" v-model="filter.phone" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Zona</h4>
                            <base-input>
                                <el-select v-model="filter.clientId" class="select-primary" name="zone" clearable>
                                    <el-option v-for="zone in zones" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Operater</h4>
                            <base-input>
                                <el-select v-model="filter.operator" class="select-primary" name="status" clearable>
                                    <el-option v-for="s in operators" class="select-primary" :label="s.name"
                                        :value="s.name" :key="s.status"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-2">
                            <h4 slot="header" class="card-title">Status</h4>
                            <base-input>
                                <el-select v-model="filter.status" class="select-primary" name="status" clearable
                                    @clear="handleClear">
                                    <el-option v-for="s in statuses" class="select-primary" :label="s.name"
                                        :value="s.status" :key="s.status"></el-option>
                                </el-select>
                            </base-input>
                        </div>
                        <div class="col-md-2">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getTickets()">Pretraži</base-button>
                            <!-- </card> -->
                        </div>

                        <div class="col-md-2" v-if="tickets.length > 0">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getSmsReport()">Preuzmi
                                izvestaj</base-button>
                            <!-- </card> -->
                        </div>
                    </div>
                    <el-table :data="tickets" v-loading="ticketsLoading">
                        <el-table-column min-width="130" prop="stamp" label="Datum">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span>{{ scope.row.client?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="plates" label="Tablice">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="number" label="Telefon">
                            <template slot-scope="scope">
                                <span>{{ scope.row.number }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="phoneCode" label="Kod">
                            <template slot-scope="scope">
                                <span>{{ scope.row.phoneCode }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="operator" label="Operater">
                            <template slot-scope="scope">
                                <span>{{ scope.row.operator }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="price" label="Cena">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="80" prop="status" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0" style="color: #9BDAED;">NIJE OBRAĐENO</span>
                                <span v-if="scope.row.status === 1" style="color: #49AFCB;">NAPLAĆENO</span>
                                <span v-if="scope.row.status === 2" style="color: #49AFCB;">NE NAPLAĆUJE SE</span>
                                <span v-if="scope.row.status === 3" style="color: red;">GREŠKA</span>
                                <span v-if="scope.row.status === 4" style="color: red;">IZDATA DK</span>

                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">

                                <base-button :type="'success'" class="btn-link" @click="getSms(scope.row)">
                                    Detalji
                                </base-button>

                            </div>
                        </el-table-column>

                    </el-table>
                    <div class="block">
                        <span class="demonstration">Ukupno stranica: {{ totalPages }}</span>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        <modal :show.sync="showSms" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showSms = false; sms = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card v-if="sms.status === 1">
                        ID: {{ sms.plateParking?.ticketNumber }}&nbsp;&nbsp;&nbsp;
                        {{ sms.plates }}&nbsp;&nbsp;&nbsp;
                        {{ sms.price }} EUR&nbsp;&nbsp;&nbsp;
                        {{ sms.client?.name }}&nbsp;&nbsp;&nbsp;
                        {{ (new Date(sms.stampLong)).toLocaleString("de-DE") }} - {{ (new
            Date(sms.plateParking?.stampEndLong)).toLocaleString("de-DE") }}<br>
                        {{ sms.number }} &nbsp;&nbsp;&nbsp; {{ sms.phoneCode }}
                        <br><br>
                        Odgovor: {{ sms.response }}
                        <!-- <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }} -->
                    </card>

                    <card v-if="sms.status === 2">
                        {{ sms.plates }}&nbsp;&nbsp;&nbsp;
                        {{ sms.client.name }}&nbsp;&nbsp;&nbsp;
                        {{ (new Date(sms.stampLong)).toLocaleString("de-DE") }}<br>
                        {{ sms.number }} &nbsp;&nbsp;&nbsp; {{ sms.phoneCode }}
                        <br><br>
                        Odgovor: {{ sms.response }}
                        <!-- <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }} -->
                    </card>

                    <card v-if="sms.status === 0">
                        NIJE OBRAĐENO<br>
                        {{ sms.plates }}&nbsp;&nbsp;&nbsp;
                        {{ sms.price }} EUR&nbsp;&nbsp;&nbsp;
                        {{ sms.client.name }}&nbsp;&nbsp;&nbsp;
                        {{ (new Date(sms.stampLong)).toLocaleString("de-DE") }}<br>
                        {{ sms.number }} &nbsp;&nbsp;&nbsp; {{ sms.phoneCode }}

                        <!-- <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }} -->
                    </card>

                    <card v-if="sms.status === 3">
                        GREŠKA<br>
                        {{ sms.plates }}&nbsp;&nbsp;&nbsp;
                        {{ sms.price }} EUR&nbsp;&nbsp;&nbsp;
                        {{ sms.client.name }}&nbsp;&nbsp;&nbsp;
                        {{ (new Date(sms.stampLong)).toLocaleString("de-DE") }}<br>
                        {{ sms.number }} &nbsp;&nbsp;&nbsp; {{ sms.phoneCode }}
                        <br><br>
                        Odgovor: {{ sms.response }}<br><br>
                        Greska: {{ sms.chargingResponse }}
                        <!-- <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }} -->
                    </card>

                    <card v-if="sms.status === 4">
                        GREŠKA<br>
                        {{ sms.plates }}&nbsp;&nbsp;&nbsp;
                        {{ sms.price }} EUR&nbsp;&nbsp;&nbsp;
                        {{ sms.client.name }}&nbsp;&nbsp;&nbsp;
                        {{ (new Date(sms.stampLong)).toLocaleString("de-DE") }}<br>
                        {{ sms.number }} &nbsp;&nbsp;&nbsp; {{ sms.phoneCode }}
                        <br><br>
                        Odgovor: {{ sms.response }}<br><br>
                    </card>
                </div>
            </div>
        </modal>
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ ticket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;

            </card>


        </modal>

        <modal :show.sync="showTicketHistory" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicketHistory = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <el-table :data="thicketHistory">
                <el-table-column min-width="150" prop="number" label="Dogadjaj">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.log }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" prop="active" label="Komentar">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.comment }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Korisnik">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.userName }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Datum">
                    <template slot-scope="scope">
                        <span>
                            {{ (new Date(scope.row.stamp)).toLocaleString("de-DE") }}
                        </span>
                    </template>
                </el-table-column>


            </el-table>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showTicketHistory = false;">
                Zatvori
            </base-button>
        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option, Pagination } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'

import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const statuses = [
    { status: 0, name: "NIJE OBRAĐENO" },
    { status: 1, name: "NAPLAĆENO" },
    { status: 2, name: "NE PLACA SE" },
    { status: 3, name: "GRESKA" },
    { status: 4, name: "IZDATA DK" }
]

const operators = [
    { status: 0, name: "TELEKOM" },
    { status: 1, name: "MTEL" },
    { status: 2, name: "ONE" }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        this.getUserPageFilter()
        this.getZones()
        // this.getKiosks()
        // this.getPaymentStatuses()
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            operators,
            statuses,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            ticketsLoading: false,
            loading: false,
            tickets: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                ticketNumber: null,
                plates: null,
                countryMark: null,
                kioskId: null,
                paymentStatusId: null,
                clientId: null,
                status: 1,
                operator: null,
                phone: null
            },
            employees: [],
            paymentStatuses: [],
            zones: [],
            ticketsLoading: false,
            ticket: {},
            showSms: false,
            sms: {},
            image: null,
            showImage: false,
            thicketHistory: [],
            showTicketHistory: false,
            kiosks: [],
            page: 1,
            max: 10,
            totalRecords: 0,
            totalPages: 0,
            totalPrice: 0
        };
    },
    methods: {
        getUserPageFilter() {
            this.loading = true

            axios.get(this.url + '/settings/getUserPageFilter?page=5').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                } else {
                    // this.$notify({
                    //     message:
                    //         result.data.reason,
                    //     timeout: 3000,
                    //     icon: 'tim-icons icon-bell-55',
                    //     horizontalAlign: "right",
                    //     verticalAlign: "top",
                    //     type: 'danger'
                    // });
                }
                this.getTickets()
            })
        },
        handleClear() {
            // Postavi željenu vrednost kada se izbriše selekcija
            this.filter.status = null; // ili -1
        },
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        getZones() {
            // this.zonesLoading = true
            axios.get(this.url + '/client/getClients').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                } else {

                }
            })
        },
        getSmsReport() {
            this.loading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/smsfront/getSmsReport', f).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    if (result.data.fileName) {

                        
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                        
                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getTickets() {
            this.ticketsLoading = true
            const f = this.filter
            f.page = this.page
            f.max = this.max
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/smsfront/getTickets', f).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getSms(sms) {
            this.ticketsLoading = true
            axios.post(this.url + '/smsfront/getSms', sms).then(result => {
                this.ticketsLoading = false

                if (result.data.result === 'ok') {
                    this.sms = result.data.sms
                    this.showSms = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        navigateToPage() {
            this.$router.push({ name: 'Administration' });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da parking mesto \"" + this.parkingSpace.number + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteParkingSpace()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        saveTicketPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar za ovu promenu.",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.ticket.comment = comment;
                        this.saveTicket()
                    }
                });
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>